try {
  const tablesEls = document.querySelectorAll(".content-block table, .widget_text table");

  tablesEls.forEach((tableEl) => {
    const parent = tableEl.parentElement;
    if (parent && parent.classList.contains("table-responsive")) {
      return;
    }

    const responsiveWrapperEl = document.createElement("div");
    responsiveWrapperEl.className = "table-responsive";

    tableEl.parentNode.insertBefore(responsiveWrapperEl, tableEl);
    responsiveWrapperEl.appendChild(tableEl);

    if (!tableEl.classList.contains("table")) {
      tableEl.classList.add("table");
    }
  });
} catch (error) {
  console.error("Error making tables responsive:", error);
}
